import src from "IMAGE";
export default { src, width: 468, height: 291, blurWidth: 0, blurHeight: 0};
